import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Login from "../pages/Login"; // Make sure this file exists
import ResetPassword from "../pages/ResetPassword"; // Password reset page
import Dashboard from "../pages/Dashboard";
import PrivateRoute from "./PrivateRoutes"; // Import PrivateRoute component
import AdminRoute from "./AdminRoute"; // Import AdminRoute component
import MessageHistory from "../pages/MessageHistory";
import CustomerDetails from "../pages/CustomerDetails";
import GroupList from "../pages/GroupList";
import GroupMembers from "../pages/GroupMembers";
import TemplateList from "../pages/TemplateList";
import TemplateCreate from "../pages/TemplateCreate";
import SubscriptionPlans from "../pages/SubscriptionPlans";
import SubscriptionManagement from "../pages/SubscriptionManagement";
import AdminDashboard from "../pages/AdminDashboard";
import UserManagement from "../pages/UserManagement";
import SubscriptionRequests from "../pages/SubscriptionRequests";
import ActivePlans from "../pages/ActivePlans";
import ExpiredPlans from "../pages/ExpiredPlans";
import SystemSettings from "../pages/SystemSettings";
import SubscriptionPlanManagement from "../pages/SubscriptionPlanManagement";
import BulkCustomerImport from "../pages/BulkCustomerImport";
import Analytics from "../pages/Analytics";
import Layout from "../layout/Layout";
import Chats from "../pages/Chats";
import BusinessProfile from "../pages/BusinessProfile";
import BroadcastList from "../pages/BroadcastList";
import BroadcastCreate from "../pages/BroadcastCreate";
import AgentManagement from "../pages/AgentManagement";
import PrivacyPolicy from "../pages/PrivacyPolicy";

const appRouter = createBrowserRouter([
  {
    path: "/",
    element: <Login />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/reset-password",
    element: <ResetPassword />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  // Regular User Routes
  {
    path: "/",
    element: <PrivateRoute element={<Layout />} />,
    children: [
      {
        path: "Dashboard",
        element: <Dashboard />,
      },
      {
        path: "messageHistory",
        element: <MessageHistory />,
      },
      {
        path: "customerDetails",
        element: <CustomerDetails />,
      },
      {
        path: "groupList",
        element: <GroupList />,
      },
      {
        path: "groups/:groupId/customers",
        element: <GroupMembers />,
      },
      {
        path: "templateList",
        element: <TemplateList />,
      },
      {
        path: "template/create",
        element: <TemplateCreate />,
      },
      {
        path: "subscription-plans",
        element: <SubscriptionPlans />,
      },
      {
        path: "subscription-management",
        element: <SubscriptionManagement />,
      },
      {
        path: "bulk-import",
        element: <BulkCustomerImport />,
      },
      {
        path: "analytics",
        element: <Analytics />,
      },
      {
        path: "chats",
        element: <Chats />,
      },
      {
        path: "business-profile",
        element: <BusinessProfile />,
      },
      {
        path: "broadcast",
        element: <BroadcastList />,
      },
      {
        path: "broadcast/create",
        element: <BroadcastCreate />,
      },
      {
        path: "agents",
        element: <AgentManagement />,
      },
    ],
  },
  // Admin Routes (separate from user routes)
  {
    path: "/admin",
    element: <AdminRoute element={<Layout />} />,
    children: [
      {
        path: "dashboard",
        element: <AdminDashboard />,
      },
      {
        path: "users",
        element: <UserManagement />,
      },
      {
        path: "subscription-requests",
        element: <SubscriptionRequests />,
      },
      {
        path: "active-plans",
        element: <ActivePlans />,
      },
      {
        path: "expired-plans",
        element: <ExpiredPlans />,
      },
      {
        path: "settings",
        element: <SystemSettings />,
      },
      {
        path: "subscription-plans/manage",
        element: <SubscriptionPlanManagement />,
      },
    ],
  },
]);

const Body = () => {
  return (
    <div className="min-h-screen">
      <RouterProvider router={appRouter} />
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default Body;
